import { generateUuid } from '@ftr/contracts/type/shared'
import { Duration } from '@js-joda/core'
import { RealTimeSttPause, RealTimeSttSegmentMap } from '../../../types'
import { OperationResult } from './operation-result'
import { bumpStartTimeEditsToProduceUniqueTime } from './unique-start-time-utils'

const DEFAULT_NEW_UTTERANCE_DURATION: Duration = Duration.ofSeconds(1)
export interface CreateRemarkAtPauseOperation {
  // e.g. Add Text on pause
  type: 'createRemarkAtPause'
  pause: RealTimeSttPause
}

export function createRemarkAtPauseTransaction(
  operation: CreateRemarkAtPauseOperation,
  segmentMap: RealTimeSttSegmentMap,
): OperationResult {
  // Find the remark in the segment map
  const firstSpeaker = segmentMap.findFirstSpeaker()
  if (!firstSpeaker) {
    throw new Error('Cannot add a remark when there are no speakers')
  }
  const newRemarkStartTime = operation.pause.startTime
  const uniqueStartTimeEdits = bumpStartTimeEditsToProduceUniqueTime(newRemarkStartTime, segmentMap, 'forward')
  const newUtteranceId = generateUuid()
  return {
    type: 'transaction',
    transaction: {
      id: generateUuid(),
      edits: [
        ...uniqueStartTimeEdits,
        {
          type: 'softCreateUtterance',
          utteranceId: newUtteranceId,
          dialect: null,
          startTime: newRemarkStartTime,
          endTime: operation.pause.startTime.plus(DEFAULT_NEW_UTTERANCE_DURATION),
          speakerId: firstSpeaker.speakerId,
        },
      ],
    },
    sideEffects: [
      {
        type: 'focusRemark',
        remarkId: newUtteranceId,
        selectionIndex: 0,
      },
    ],
  }
}
